const state = {
    // 登录账号的所在机构类型 1：腾慧  2：珊瑚
    isShanhu: localStorage.getItem('tengface_is_shanhu') || 2,
    org_id: localStorage.getItem('tengface_org_id') || "",
    fans_id:localStorage.getItem('tengface_fans_id') || "",
    remark:localStorage.getItem('tengface_remark')||''
}

const getters = {
    getRemark(state){
        return state.remark
    },
    getOrgId(state){
		return state.org_id
	},
    getFansId(state){
		return state.fans_id
	},
    getIsShanhuState(state) {
        try {
            return Number(state.isShanhu) === 2
        } catch (error) {
            return false
        }
    }
}

const actions = {
   
}

const mutations = {
   setOrgID(state, data){
       state.org_id = data
   },
   setFansId(state,data){
    state.fans_id = data
   },
   setIsShanhuState(state, data){
       state.isShanhu = data
   },
   setRemark(state, data){
    state.remark = data
    localStorage.setItem('tengface_remark',data)
},
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
